// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__vOOQv"};